import { gql } from '@apollo/client';

interface NewRoleOrganisationInput {
  name: string;
  code: string;
}

export interface CreateNewRoleInput {
  name: string;
  description: string;
  permissions: string[];
  organisation: NewRoleOrganisationInput;
}

export interface CreateNewRoleData {
  createCustomRole: CreateNewRoleData;
}

export const CREATE_NEW_ROLE = gql`
  mutation createCustomRole($input: CreateCustomRoleInput!) {
    createCustomRole(input: $input) {
      message
    }
  }
`;
